/**
 * @generated SignedSource<<cef5a54a36e20b4f222f84e05068ac74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "target",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UrlRedirectionsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlRedirection",
        "kind": "LinkedField",
        "name": "urlRedirections",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UrlRedirectionsManagerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UrlRedirection",
        "kind": "LinkedField",
        "name": "urlRedirections",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e33eba8d77820be5abe4267b4f1c66c0",
    "id": null,
    "metadata": {},
    "name": "UrlRedirectionsManagerQuery",
    "operationKind": "query",
    "text": "query UrlRedirectionsManagerQuery {\n  urlRedirections {\n    source\n    target\n    id\n  }\n}\n"
  }
};
})();

node.hash = "551d7d113a657958b7a7eefbc964a540";

module.exports = node;
